import { TextArea } from 'semantic-ui-react';
import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';
import TextareaWidget from '@plone/volto/components/manage/Widgets/TextareaWidget';
import { CharCounter } from 'volto-ministerio-publico-federal/components/WorkflowState';
import {
  NEWS_DESCRIPTION_MAX,
  NEWS_PORTAL_TYPES,
} from 'volto-ministerio-publico-federal/constants';

interface NewsDescriptionWidgetProps {
  id: string;
  value?: string;
  placeholder?: string;
  isDisabled?: boolean;
  formData?: { '@type'?: string };
  onChange: (id: string, value?: string) => void;
  [key: string]: unknown;
}

/**
 * Campo `description` do formulário. Nas notícias acrescenta o mesmo contador
 * do bloco Descrição (`CharCounter`): o limite não trava a digitação, mas
 * impede salvar (ver `excedeLimitesNoticia`). Nos demais tipos é o textarea
 * padrão do Volto.
 *
 * O contador fica dentro do `FormFieldWrapper`, na coluna do campo, para
 * alinhar à direita do textarea e acima do texto de ajuda.
 */
const NewsDescriptionWidget = (props: NewsDescriptionWidgetProps) => {
  const { id, value, placeholder, isDisabled, formData, onChange } = props;
  const isNews = NEWS_PORTAL_TYPES.includes(formData?.['@type'] ?? '');

  if (!isNews) return <TextareaWidget {...props} />;

  return (
    <FormFieldWrapper {...props} className="textarea">
      <TextArea
        id={`field-${id}`}
        name={id}
        value={value || ''}
        disabled={isDisabled}
        placeholder={placeholder}
        onChange={({ target }) =>
          onChange(
            id,
            (target as HTMLTextAreaElement).value === ''
              ? undefined
              : (target as HTMLTextAreaElement).value,
          )
        }
      />
      <div className="mpf-editor-counter">
        <CharCounter length={(value ?? '').length} max={NEWS_DESCRIPTION_MAX} />
      </div>
    </FormFieldWrapper>
  );
};

export default NewsDescriptionWidget;
